import { ChangeEventHandler, createContext } from 'react'
import { GroupedVirtuosoHandle } from 'react-virtuoso'
import { ISelectProps } from './types'

interface IContext {
  onClose: () => void
  onSearch: (_event: ChangeEventHandler<HTMLInputElement>) => void
  onSearchBlur: () => void
  onSelect: (_n: number, close?: boolean) => void
  getSelected: () => (string | number)[]
  data: Readonly<ISelectProps['data']>
  hideSearch?: boolean
  compact?: boolean
  setVirtualListRef: (ref) => void
  getVirtualListRef: () => GroupedVirtuosoHandle | null
}

const emptyFn = () => {
  // do nothing
}

export const Context = createContext<IContext>({
  onClose: emptyFn,
  onSearch: emptyFn,
  onSearchBlur: emptyFn,
  onSelect: emptyFn,
  getSelected: () => [],
  data: [],
  hideSearch: false,
  compact: false,
  setVirtualListRef: emptyFn,
  getVirtualListRef: () => null,
})
